import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { fileIcons } from "@pages/project-details/project-markups/sidepanel/markup-sidepanel-utils";
import { getFileExtension, isImageFileType } from "@utils/file-utils";
import { isEmpty } from "es-toolkit/compat";
import { useState } from "react";

/** Width of the thumbnail slot in the attachment list */
const THUMBNAIL_WIDTH = "60px";

/** Height of the thumbnail slot in the attachment list */
const THUMBNAIL_HEIGHT = "2.75rem";
/**
 * Renders the thumbnail slot of an attachment row.
 *
 * Images use the backend thumbnail when available, otherwise the original file is shown scaled down.
 * Non-images, and images whose blob is no longer reachable, fall back to the file type icon.
 */
export function AttachmentThumbnail(t0) {
  const $ = _c(19);
  const {
    attachment
  } = t0;
  const [failedSrc, setFailedSrc] = useState();
  let imageSrc;
  let t1;
  if ($[0] !== attachment.name || $[1] !== attachment.signedThumbnailUri || $[2] !== attachment.signedUri || $[3] !== failedSrc) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const fileExtension = getFileExtension(attachment.name);
      let t2;
      if ($[6] !== attachment.signedThumbnailUri || $[7] !== attachment.signedUri) {
        t2 = isEmpty(attachment.signedThumbnailUri) ? attachment.signedUri : attachment.signedThumbnailUri;
        $[6] = attachment.signedThumbnailUri;
        $[7] = attachment.signedUri;
        $[8] = t2;
      } else {
        t2 = $[8];
      }
      imageSrc = t2;
      const shouldShowImage = isImageFileType(fileExtension) && !!imageSrc && failedSrc !== imageSrc;
      if (!shouldShowImage) {
        const FileIcon = fileIcons[fileExtension.toLowerCase()] ?? fileIcons.default;
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = {
            height: THUMBNAIL_HEIGHT,
            display: "flex",
            alignItems: "center"
          };
          $[9] = t3;
        } else {
          t3 = $[9];
        }
        let t4;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = {
            width: THUMBNAIL_WIDTH,
            height: "32px"
          };
          $[10] = t4;
        } else {
          t4 = $[10];
        }
        let t5;
        if ($[11] !== FileIcon) {
          t5 = <Box sx={t3}><FileIcon sx={t4} /></Box>;
          $[11] = FileIcon;
          $[12] = t5;
        } else {
          t5 = $[12];
        }
        t1 = t5;
        break bb0;
      }
    }
    $[0] = attachment.name;
    $[1] = attachment.signedThumbnailUri;
    $[2] = attachment.signedUri;
    $[3] = failedSrc;
    $[4] = imageSrc;
    $[5] = t1;
  } else {
    imageSrc = $[4];
    t1 = $[5];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[13] !== imageSrc) {
    t2 = () => setFailedSrc(imageSrc);
    $[13] = imageSrc;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: THUMBNAIL_WIDTH,
      minWidth: THUMBNAIL_WIDTH,
      height: THUMBNAIL_HEIGHT,
      objectFit: "cover",
      flexShrink: 0
    };
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== imageSrc || $[17] !== t2) {
    t4 = <Box component="img" src={imageSrc} alt="attachment annotation" loading="lazy" decoding="async" onError={t2} data-testid="markup-side-panel-attachment-image" sx={t3} />;
    $[16] = imageSrc;
    $[17] = t2;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}